<template>
  <div
    class="trezo-card p-[20px] md:p-[25px] rounded-md"
    style="background: linear-gradient(164deg, #b95232 3.1%, #eb6d5c 99.22%)"
  >
    <div class="trezo-card-content md:py-[30px] mx-auto md:max-w-[209px]">
      <h3 class="text-white text-lg md:text-xl leading-[1.3] mb-[16px]">
        Have A Team More Than 10 Members?
      </h3>
      <a
        href="#"
        target="_blank"
        class="inline-block rounded-md bg-gray-900 text-white transition-all text-[15px] md:text-md font-medium py-[6px] px-[16.5px] hover:bg-gray-800 mb-[15px] md:mb-[30px]"
      >
        Upgrade Plans
      </a>
      <img src="@/assets/images/paper.png" class="mx-auto" alt="paper-image" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "UpgradePlans",
});
</script>
